import { useParams, useSearchParams } from "react-router-dom";
import ChipTabs from "../../../components/ChipsTabs";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import { tabs } from "./utils/ClinicTabs";
import { Typography } from "@mui/material";
import { useGetClinicPermissions } from "../../../hooks/useGetClinics";
import Loader from "../../../components/loader/Loader";
import ErrorFullScreenMessage from "../../../components/fullScreenMessage/ErrorFullScreenMessage";

// Active tab lives in the URL so going back from a sub-page (e.g. an employee's
// details) returns to the same tab instead of "General".
const CLINIC_TAB_PARAM = "clinicTab";

// Master-only page (cross-clinic view) — block every non-master role.
export default function ClinicPage() {
  const { clinicName, id } = useParams();
  const { data: clinicPermissions, isLoading, error } = useGetClinicPermissions(id);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = parseInt(searchParams.get(CLINIC_TAB_PARAM), 10);
  const initialTab = isNaN(tabFromUrl)
    ? 0
    : Math.max(0, Math.min(tabFromUrl, tabs.length - 1));
    
  const labels = [];
  const content = [];
  const icons = [];
  const tabTestIds = [];

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }

  // Only show what the clinic's tier lets the clinic itself see, so master
  // doesn't report "bugs" in features the clinic can't actually use.
  const visibleTabs = tabs.filter(
    (tab) => !tab.permission || clinicPermissions.includes(tab.permission),
  );

  visibleTabs.forEach((tab) => {
    labels.push(tab.title);
    content.push(tab.component);
    icons.push(tab.icon);
    tabTestIds.push(
      `clinic.tabs.${tab.title.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}-tab`
    );
  });

  function handleTabChange(index) {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set(CLINIC_TAB_PARAM, index);
        return next;
      },
      { replace: true }
    );
  }

  return (
    <PageContentWrapper>
      <Typography
        sx={{
          textAlign: "center",
          verticalAlign: "middle",
          marginBottom: "15px"
        }}
      >
        <h1>{clinicName}</h1>
      </Typography>
      <ChipTabs
        lsKey={"CLINIC_PAGE_LS_KEY"}
        tabContent={content}
        tabLabels={labels}
        icons={icons}
        tabTestIds={tabTestIds}
        wrapperMaxWidth="90vw"
        lastIndex={initialTab}
        onTabChange={handleTabChange}
      />
    </PageContentWrapper>
  );
}
